/* eslint-disable */
import * as util from "@/api/gmapKey";

const state = {
};


const mutations = {
  
};

const actions = {
    listData({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.listData(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    downloadExcelContact({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.downloadExcelContact(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    downloadExcelBc({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.downloadExcelBc(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    headerList({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.headerList(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    createHeader({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.createHeader(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setupKey({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.setupKey(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },

    getGmapKey({ commit }) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.getGmapKey().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/gmapKey.js